import React from 'react';
import TextField from '@mui/material/TextField';

//Create a docstring for the component
/**
 * NumberInput is a reusable component that renders a number input.
 * @param {number} value - The value/label of the number input.
 * @param {number} min - The minimum value of the number input.
 * @param {number} max - The maximum value of the number input.
 * @param {number} step - The step value to increase/decrease the value by.
 * @param {function} onChange - The function that handles the change state of the number input.
 * @param {string} location - The location i.e. on which page of the number input .
 * @param {string} className - The class name of the number input.
 * @param {string} dataCy - The data-cy attribute for the cypress scripts.
 **/

const NumberInput = ({ value, min, max, step, onChange, location, className, dataCy,disabled }) => {
  return (
    <div className='text-box-number-input'>
      <TextField
              value={value}
              className={className}
              data-cy={dataCy}
        onChange={(e) => {
          const value = e.target.value;
          if (value === '' || (parseFloat(value) >= min && parseFloat(value) <= max)) {
            onChange(value === '' ? '' : parseFloat(value));
          }
        }}
        inputProps={{ min, max, step }}
      type="number"   
      disabled={disabled} 
      />
    </div>
  );
};

export default NumberInput;
